var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("day-configurator-header"),
      _vm._v(" "),
      _vm.$route.name === "empty-configurator"
        ? _c("day-configurator-new")
        : _c("router-view", { key: _vm.$route.fullPath }),
      _vm._v(" "),
      _vm.offerAlreadySent
        ? _c("div", {
            staticClass: "offer-already-sent-overlay",
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.duplicateSchedule($event)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }